// tab-badge.js
let baseTitle = '';
let originalFaviconHref = '';
let faviconLink = null;

const ensureFaviconLink = () => {
    if (!faviconLink) {
        faviconLink = document.querySelector('link[rel*="icon"]');
        if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.setAttribute('rel', 'icon');
            document.head.appendChild(faviconLink);
        }
    }
    if (!originalFaviconHref) originalFaviconHref = faviconLink.getAttribute('href') || '';
    return faviconLink;
};

export const setTitleBadge = (count, appTitle) => {
    if (!baseTitle) baseTitle = appTitle || document.title || 'App';
    const n = Number(count) || 0;
    if (n > 0) {
        // 🔴 + number (titles can only show text/emoji)
        document.title = `🔴 ${n > 99 ? '99+' : n} — ${baseTitle}`;
    } else {
        document.title = baseTitle;
    }
};

export const setFaviconBadge = async (count, opts = {}) => {
    const n = Number(count) || 0;
    const {
        size = 64,
        badgeColor = '#dc3545',   // Bootstrap danger
        textColor = '#fff',
        font = 'bold 34px system-ui, -apple-system, Segoe UI, Roboto, Arial'
    } = opts;

    const link = ensureFaviconLink();

    if (n <= 0) {
        if (originalFaviconHref) link.href = originalFaviconHref;
        return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = size;
    canvas.height = size;

    const drawBadge = () => {
        // red dot
        const r = Math.round(size * 0.32);
        const cx = size - r + Math.round(size * 0.06);
        const cy = r - Math.round(size * 0.06);

        ctx.fillStyle = badgeColor;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fill();

        // number
        const text = n > 99 ? '99+' : String(n);
        ctx.fillStyle = textColor;
        ctx.font = font;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.save();
        // shrink font a bit for 3+ chars
        if (text.length >= 3) ctx.font = 'bold ' + Math.round(size * 0.42) + 'px system-ui';
        ctx.fillText(text, cx, cy + 1);
        ctx.restore();
    };

    // draw base icon (if any), else blank
    const src = originalFaviconHref;
    if (src) {
        await new Promise(resolve => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                ctx.drawImage(img, 0, 0, size, size);
                drawBadge();
                resolve();
            };
            img.onerror = () => { drawBadge(); resolve(); };
            img.src = src;
        });
    } else {
        drawBadge();
    }

    link.type = 'image/png';
    link.href = canvas.toDataURL('image/png');
};
